import { tw } from "@careinfo/tailwind";

export const TableBodyLoading = ({
  noOfColumns = 6,
}: {
  noOfColumns?: number;
}) => (
  <tbody className={tw`h-8 animate-pulse  bg-gray-200 hover:cursor-wait`}>
    {Array.from({ length: 10 }).map((_, index) => (
      <tr
        key={index}
        className={tw`bg-gray-200 py-3 h-8 odd:bg-white hover:bg-gray-100 hover:transition-all`}
      >
        {Array.from({ length: noOfColumns }).map((_, i) => (
          <td key={i} className={tw`py-3 text-left px-5 `}></td>
        ))}
      </tr>
    ))}
  </tbody>
);

export default function Template({ addNew, noOfColumns, customSearch }) {
  return (
    <div className={tw`space-y-4 rounded-md hover:cursor-wait mt-4`}>
      {customSearch && (
        <div className={tw`w-full flex justify-between animate-pulse`}>
          <div className={tw`flex items-center gap-x-4`}>
            <div
              className={tw` border p-2 bg-gray-200 rounded-md min-w-64 animate-pulse h-10 w-96`}
            ></div>
            {addNew && (
              <div
                className={tw`bg-primary-light py-1 animate-pulse w-44 h-10 px-5 rounded-md`}
              ></div>
            )}
          </div>
        </div>
      )}
      <div
        className={tw`w-full bg-white rounded-md overflow-hidden`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <table className={tw`w-full overflow-hidden z-0 rounded-t-md`}>
          <thead className={tw`w-full`}>
            <tr className={tw`bg-primary animate-pulse`}>
              {Array.from({ length: noOfColumns }).map((_, i) => (
                <th key={i} className={tw`py-5 text-left px-5 `}></th>
              ))}
            </tr>
          </thead>
          <TableBodyLoading noOfColumns={noOfColumns} />
        </table>
        <div
          className={tw`flex bg-white py-2 my-4 w-full justify-center gap-4`}
        >
          <button className={tw`border hidden md:block rounded p-1`} disabled>
            {"<<"}
          </button>
          <button className={tw`border rounded p-1`} disabled>
            {"<"}
          </button>
          <button className={tw`border rounded p-1`} disabled>
            {">"}
          </button>
          <button className={tw`border hidden md:block rounded p-1`} disabled>
            {">>"}
          </button>
          <span className={tw`flex items-center gap-1`}>
            <div>Page</div>
            <strong className={tw`flex items-center gap-1`}>
              <span
                className={tw`inline-block animate-pulse h-4 w-8 bg-gray-200 rounded-md`}
              ></span>
              of
              <span
                className={tw`inline-block animate-pulse h-4 w-8 bg-gray-200 rounded-md`}
              ></span>
            </strong>
          </span>
          <p className={tw`flex items-center gap-1 mt-1`}>
            <span>All:</span>
            <span
              className={tw`inline-block animate-pulse h-4 w-8 bg-gray-200 rounded-md`}
            ></span>
          </p>
        </div>
      </div>
    </div>
  );
}
